package nl.astraeus.wiki.service

import kotlinx.browser.window
import nl.astraeus.wiki.messages.GoogleLoginMessage
import nl.astraeus.wiki.messages.GoogleLoginResult
import nl.astraeus.wiki.messages.MessageHeader
import nl.astraeus.wiki.messages.MessageType
import nl.astraeus.wiki.ws.WebsocketConnection
import org.w3c.dom.url.URLSearchParams

object OauthService {

  fun handleGoogleOauth() {
    console.log("window.location", window.location)
    val params = URLSearchParams(window.location.search)

    val code = params.get("code") ?: ""
    val state = params.get("state") ?: ""

    if (code.isNotEmpty() && state.isNotEmpty()) {
      WebsocketConnection.send(
        GoogleLoginMessage(
          code,
          state
        )
      ) { msg ->
        msg.checkType(MessageType.GOOGLE_LOGIN_RESPONSE)

        val message = GoogleLoginResult(msg.message)

        if (message.getHeader(MessageHeader.RESULT) == "SUCCESS") {
          window.location.replace(window.location.origin)
        } else {
          error("Login error: ${message.getHeader(MessageHeader.REASON)}")
        }
      }
    } else {
      error("No code or state found!")
    }
  }

}
